import {
  inboundShipmentIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { transferSessionIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getUnplacedShipmentReceipt = {
  name: "getUnplacedShipmentReceipt" as const,
  input: z.object({ inboundShipmentId: inboundShipmentIdFormat.schema }),
  output: z.object({
    receipt: z
      .object({
        transferSessionId: transferSessionIdFormat.schema,
        locationId: locationIdFormat.schema,
        unplacedQuantity: z.number().int().nonnegative(),
        blocksReceiving: z.boolean(),
      })
      .nullable(),
  }),
};
